<template>
    <v-app id="app_daily_collections">
        <v-container fluid>
            <v-row class="pl-2 pr-6">
                <v-col class="mt-3" cols="7">
                    <p class="custom_page_main_title">DAILY COLLECTIONS</p>
                    <p class="custom_page_main_sub_title" style="opacity: 0.6">Review daily sales data from different
                        retail locations using invoice records.</p>
                </v-col>
                <v-col class="px-4 mt-5" cols="5">
                    <v-row class="custom_tool_bar_style">
                        <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
                        <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
                            <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>

            <v-card class="custom_card_box mt-8" elevation="1" border="sm opacity-1" rounded="lg">
                <v-card-text class="custom_tool_bar_style">
                    <v-btn class="custom_pdf_btn" variant="outlined" @click="exportPDF">
                        <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
                    </v-btn>
                    <v-btn class="custom_excel_btn ml-4" variant="outlined" @click="exportExcel">
                        <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
                    </v-btn>
                </v-card-text>

                <v-divider thickness="2"></v-divider>

                <v-expansion-panels v-model="panelOpen" multiple>
                    <v-expansion-panel value="filters" elevation="0">
                        <v-expansion-panel-title expand-icon="mdi-menu-down">
                            <v-icon class="mr-3">mdi-filter-menu-outline</v-icon>
                            <span class="text-body-1 font-weight-bold">FILTERS</span>
                        </v-expansion-panel-title>
                        <v-expansion-panel-text>
                            <v-row class="mt-2" dense>
                                <v-col cols="12" md="4" class="py-1">
                                    <v-date-input v-model="dates" append-inner-icon="mdi-close"
                                        prepend-inner-icon="$calendar" prepend-icon="" label="Select Date Range"
                                        multiple="range" density="comfortable" class="custom_input_field_color"
                                        variant="outlined" @click:append-inner="clearDateRange"></v-date-input>
                                </v-col>

                                <v-col cols="12" md="4" class="py-1">
                                    <v-select 
                                    v-model="selectedAgent" 
                                    :items="agentListsWithDetails"
                                    density="comfortable" 
                                    clearable 
                                    item-title="text" 
                                    item-value="value"
                                    class="custom_input_field_color" 
                                    label="Sales Rep" 
                                    multiple
                                    placeholder="Select sales representative" 
                                    variant="outlined"
                                    >
                                    <template v-slot:item="{ props, item }">
                                        <v-list-item v-bind="props" :title="undefined">
                                        <template v-slot:prepend>
                                            <v-checkbox-btn :model-value="props.selected" @click="props.select"></v-checkbox-btn>
                                        </template>
                                        <v-list-item-title>{{ item.raw.text }}</v-list-item-title>
                                        <v-list-item-subtitle style="color: #01579B; font-size: 11px;">
                                            REG NO: {{ item.raw.registration }}
                                        </v-list-item-subtitle>
                                        </v-list-item>
                                    </template>

                                    <template v-slot:chip="{ props, item }">
                                        <v-chip
                                        v-bind="props"
                                        color="#e7e7e7"
                                        variant="flat"
                                        class="text-black font-weight-medium"
                                        size="small"
                                        closable
                                        >
                                        {{ item.raw.text }}
                                        </v-chip>
                                    </template>
                                    </v-select>
                                </v-col>

                                <v-col cols="12" md="4" class="py-1">
                                    <v-autocomplete 
                                    v-model="selectedCompany" 
                                    :items="companyLists" 
                                    item-title="text"
                                    item-value="value" 
                                    label="Piyestra Company" 
                                    placeholder="Select company"
                                    variant="outlined" 
                                    density="comfortable"
                                    class="custom_input_field_color" 
                                    multiple 
                                    clearable
                                    >
                                    <template v-slot:chip="{ props, item }">
                                        <v-chip
                                        v-bind="props"
                                        color="#e7e7e7"
                                        variant="flat"
                                        class="text-black font-weight-medium"
                                        size="small"
                                        closable
                                        >
                                        {{ item.title }}
                                        </v-chip>
                                    </template>
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" md="4" class="py-1">
                                    <v-autocomplete 
                                    v-model="selectedDealer" 
                                    :items="dealerListsWithDetails" 
                                    clearable
                                    density="comfortable" 
                                    item-title="text" 
                                    item-value="value" 
                                    label="Dealer"
                                    class="custom_input_field_color" 
                                    multiple 
                                    placeholder="Select dealer"
                                    variant="outlined"
                                    >
                                    <template v-slot:item="{ props, item }">
                                        <v-list-item v-bind="props" :title="undefined">
                                        <template v-slot:prepend>
                                            <v-checkbox-btn :model-value="props.selected" @click="props.select"></v-checkbox-btn>
                                        </template>
                                        <v-list-item-title>{{ item.raw.text }}</v-list-item-title>
                                        <v-list-item-subtitle style="color: #01579B; font-size: 11px;">
                                            REG NO: {{ item.raw.registration }}
                                        </v-list-item-subtitle>
                                        </v-list-item>
                                    </template>

                                    <template v-slot:chip="{ props, item }">
                                        <v-chip
                                        v-bind="props"
                                        color="#e7e7e7"
                                        variant="flat"
                                        class="text-black font-weight-medium"
                                        size="small"
                                        closable
                                        >
                                        {{ item.raw.text }}
                                        </v-chip>
                                    </template>
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" md="4" class="py-1">
                                    <v-autocomplete 
                                    v-model="selectDistrict" 
                                    :items="areaLists" 
                                    item-title="text"
                                    item-value="value" 
                                    label="Area" 
                                    placeholder="Select area"
                                    variant="outlined" 
                                    density="comfortable"
                                    class="custom_input_field_color" 
                                    multiple 
                                    clearable
                                    >
                                    <template v-slot:chip="{ props, item }">
                                        <v-chip
                                        v-bind="props"
                                        color="#e7e7e7"
                                        variant="flat"
                                        class="text-black font-weight-medium"
                                        size="small"
                                        closable
                                        >
                                        {{ item.title }}
                                        </v-chip>
                                    </template>
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" md="4" class="py-1">
                                    <v-autocomplete 
                                    v-model="selectedStatus" 
                                    :items="getStatus" 
                                    item-title="text"
                                    item-value="value" 
                                    label="Status" 
                                    placeholder="Select status"
                                    variant="outlined" 
                                    density="comfortable"
                                    class="custom_input_field_color" 
                                    multiple 
                                    clearable
                                    >
                                    <template v-slot:chip="{ props, item }">
                                        <v-chip
                                        v-bind="props"
                                        color="#e7e7e7"
                                        variant="flat"
                                        class="text-black font-weight-medium"
                                        size="small"
                                        closable
                                        >
                                        {{ item.title }}
                                        </v-chip>
                                    </template>
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" md="4" class="py-1">
                                    <v-autocomplete 
                                    v-model="selectedReceiptType" 
                                    :items="receiptTypes" 
                                    item-title="text"
                                    item-value="value" 
                                    label="Receipt Type" 
                                    placeholder="Select receipt type"
                                    variant="outlined" 
                                    density="comfortable"
                                    class="custom_input_field_color" 
                                    multiple 
                                    clearable
                                    >
                                    <template v-slot:chip="{ props, item }">
                                        <v-chip
                                        v-bind="props"
                                        color="#e7e7e7"
                                        variant="flat"
                                        class="text-black font-weight-medium"
                                        size="small"
                                        closable
                                        >
                                        {{ item.title }}
                                        </v-chip>
                                    </template>
                                    </v-autocomplete>
                                </v-col>

                                <!-- Search field taking up 2 columns width (md="8") -->
                                <v-col cols="12" md="8" class="py-1">
                                    <v-text-field v-model="search" clearable label="Search"
                                        placeholder="Search by dealer, sales rep, company, receipt type..."
                                        variant="outlined" density="comfortable"
                                        class="custom_input_field_color"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-divider class="mb-3 mt-2"></v-divider>
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                </v-expansion-panels>

                <v-card-text>
                    <v-data-table :headers="headers" :items="filteredCollections" :search="search" :items-per-page="5"
                        item-value="id" class="px-2 custom_table_curved" @page-count="totalPages = $event">

                        <template v-slot:[`item.dealer_name`]="{ item }">
                            <p class="font-weight-medium text-body-2 mt-2">{{ item.dealer_name || 'Laksiri Homes' }}</p>
                        </template>

                        <template v-slot:[`item.agent.name`]="{ item }">
                            <p class="font-weight-medium text-body-2 mt-2">{{ item.agent?.name || 'Mr. Nehan Godage' }}
                            </p>
                            <v-divider class="mb-2" thickness="2"></v-divider>
                            <p style="color: #01579B; font-size: 10px" class="mb-2">REG NO: {{
                                item.agent?.registration_num || '1034' }}</p>
                        </template>

                        <template v-slot:[`item.total`]="{ item }">
                            <p style="color: #01579B;" class="text-body-2 font-weight-medium mt-2">LKR. {{
                                formatNumber(item.total || 72128.00) }}</p>
                        </template>

                        <template v-slot:[`item.receipt_type`]="{ item }">
                            <v-chip v-if="item.receipt_type === 'Cash'" class="custom_green_chip mb-3" size="small"
                                variant="outlined">
                                Cash
                                <v-icon class="ml-9">mdi-cash</v-icon>
                            </v-chip>
                            <v-chip v-else-if="item.receipt_type === 'Credit'" class="custom_blue_chip mb-3"
                                size="small" variant="outlined">
                                Credit
                                <v-icon class="ml-9">mdi-credit-card</v-icon>
                            </v-chip>
                            <v-chip v-else class="custom_orange_chip mb-3" size="small" variant="outlined">
                                {{ item.receipt_type || 'Cash' }}
                                <v-icon class="ml-9">mdi-receipt</v-icon>
                            </v-chip>
                        </template>

                        <template v-slot:[`item.date`]="{ item }">
                            <div class="column-content">{{ item.date || '2024-01-22' }}</div>
                        </template>

                        <template v-slot:[`item.company_name`]="{ item }">
                            <div class="column-content">{{ item.company_name || 'Piyestra Furniture Pvt. Ltd' }}</div>
                        </template>

                        <template v-slot:[`item.action`]="{ item }">
                            <v-menu transition="slide-x-transition" id="app_daily_collections">
                                <template v-slot:activator="{ props }">
                                    <v-btn style="background-color: #800080; color: white;" variant="flat" size="large" v-bind="props" border="1px">
                                        ACTIONS &nbsp; &nbsp;<v-icon>mdi-menu-down</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item v-if="permissions.read" @click="viewItem(item)">
                                        <v-list-item-title class="custom_font_color_view">VIEW</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="permissions.delete" @click="confirmDelete(item)">
                                        <v-list-item-title class="custom_font_color_delete"
                                            style="color: #BB0000 !important;">DELETE</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>

            <!-- Delete confirmation dialog -->
            <v-dialog v-model="deleteDialog" id="app_total_collections" max-height="500" max-width="500" persistent>
                <v-card id="app_total_collections" rounded="md">
                    <div class="pa-4">
                        <v-card color="#F0F0F0" flat>
                            <template v-slot:prepend>
                                <v-card-title class="text-subtitle-1 font-weight-bold">DELETE COLLECTION
                                    DATA</v-card-title>
                            </template>
                            <v-spacer></v-spacer>
                            <template v-slot:append>
                                <v-btn @click="deleteDialog = false" icon="mdi-close" size="x-small"></v-btn>
                            </template>
                        </v-card>

                        <v-card color="white" flat class="mt-3">
                            <v-card-item>
                                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                                    <v-icon color="warning" size="small">mdi-alert</v-icon>
                                    &nbsp;&nbsp;Do you want to delete this collection record?
                                </v-card-title>

                                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                                    This collection record will be deleted immediately. Once deleted, it can no longer
                                    be used for
                                    any
                                    purpose. <span style="color: #0D47A1; font-weight: 500;">Further, this module might
                                        be related
                                        with some other module, so please confirm before deleting this.</span>
                                </p>

                                <v-divider class="mt-4"></v-divider>

                                <div class="float-end mt-4">
                                    <v-btn class="ml-3" style="background-color: #D32F2F; color: white;"
                                        @click="deleteItem">DELETE</v-btn>
                                    <v-btn class="ml-3" style="background-color: #9E9E9E; color: white;"
                                        @click="deleteDialog = false">CANCEL</v-btn>
                                </div>
                            </v-card-item>
                        </v-card>
                    </div>
                </v-card>
            </v-dialog>
        </v-container>
    </v-app>
</template>

<script>
import axios from 'axios';
import { EventBus } from "@/plugins/event-bus";
import { mapActions } from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { getPermissions } from "@/plugins/permissions";

export default {
    components: {
        // No imported component needed for now
    },

    data() {
        return {
            panelOpen: ['filters'],
            dates: [],
            search: '',
            selectedAgent: [],
            selectedCompany: [],
            selectedDealer: [],
            selectDistrict: [],
            selectedStatus: [],
            selectedReceiptType: [],

            agentListsWithDetails: [
                { text: 'Mr. Nehan Godage', value: 'nehan_godage', registration: '1034' },
                { text: 'Mr. Cherith Maitreya', value: 'cherith', registration: '4567' },
                { text: 'Mr. Kumarasri Tilakaratne', value: 'kumarasri', registration: '2389' },
                { text: 'Mr. Supun Kanakeratne', value: 'supun', registration: '8945' },
                { text: 'Mr. Laksiri Homes', value: 'laksiri', registration: '5678' },
            ],

            dealerListsWithDetails: [
                { text: 'Laksiri Homes', value: 'laksiri_homes', registration: '101227' },
                { text: 'Saviro Furniture', value: 'saviro', registration: '101228' },
                { text: 'Gunawardana Furniture', value: 'gunawardana', registration: '101229' },
                { text: 'Manditha Furniture', value: 'manditha', registration: '001256' },
                { text: 'Keson Furniture', value: 'keson', registration: '101230' },
            ],

            areaLists: [
                { text: 'Colombo | C117-COIN', value: 'colombo' },
                { text: 'Meegoda | C152-MESJ', value: 'meegoda' },
                { text: 'Rathnapura | C321-RAIN', value: 'rathnapura' },
                { text: 'Kegalle | C751-KEKL', value: 'kegalle' },
                { text: 'Galle | G101-GALE', value: 'galle' },
            ],

            getStatus: [
                { text: 'Completed', value: 'completed' },
                { text: 'Pending', value: 'pending' },
                { text: 'Processing', value: 'processing' },
                { text: 'Cancelled', value: 'cancelled' },
            ],

            receiptTypes: [
                { text: 'Cash', value: 'Cash' },
                { text: 'Credit', value: 'Credit' },
                { text: 'Cheque', value: 'Cheque' },
                { text: 'Bank Transfer', value: 'Bank Transfer' },
                { text: 'Card Payment', value: 'Card Payment' },
            ],

            companyLists: [
                { text: 'Piyestra Furniture Pvt. Ltd', value: 'piyestra_main' },
                { text: 'Piyestra North', value: 'piyestra_north' },
                { text: 'Piyestra South', value: 'piyestra_south' },
                { text: 'Piyestra East', value: 'piyestra_east' },
                { text: 'Piyestra West', value: 'piyestra_west' },
            ],

            deleteDialog: false,
            itemToDelete: null,

            headers: [
                { text: 'Dealer Name', value: 'dealer_name', title: 'DEALER NAME', sortable: true },
                { text: 'Sales Rep Name', value: 'agent.name', title: 'SALES REP NAME', sortable: true },
                { text: 'Total', value: 'total', title: 'TOTAL', sortable: true },
                { text: 'Receipt Type', value: 'receipt_type', title: 'RECEIPT TYPE', sortable: true },
                { text: 'Date', value: 'date', title: 'DATE', sortable: true },
                { text: 'Company Name', value: 'company_name', title: 'COMPANY NAME', sortable: true },
                { text: 'Actions', value: 'action', sortable: false, title: 'ACTION' },
            ],

            collections: [
                {
                    id: 1,
                    dealer_name: 'Laksiri Homes',
                    agent: { name: 'Mr. Nehan Godage', registration_num: '1034' },
                    total: 72128.00,
                    receipt_type: 'Cash',
                    date: '2024-01-22',
                    company_name: 'Piyestra Furniture Pvt. Ltd'
                },
                {
                    id: 2,
                    dealer_name: 'Saviro Furniture',
                    agent: { name: 'Mr. Cherith Maitreya', registration_num: '4567' },
                    total: 45320.50,
                    receipt_type: 'Credit',
                    date: '2024-01-22',
                    company_name: 'Piyestra North'
                },
                {
                    id: 3,
                    dealer_name: 'Gunawardana Furniture',
                    agent: { name: 'Mr. Kumarasri Tilakaratne', registration_num: '2389' },
                    total: 89150.75,
                    receipt_type: 'Cash',
                    date: '2024-01-22',
                    company_name: 'Piyestra South'
                },
                {
                    id: 4,
                    dealer_name: 'Manditha Furniture',
                    agent: { name: 'Mr. Supun Kanakeratne', registration_num: '8945' },
                    total: 125000.00,
                    receipt_type: 'Bank Transfer',
                    date: '2024-01-21',
                    company_name: 'Piyestra East'
                },
                {
                    id: 5,
                    dealer_name: 'Keson Furniture',
                    agent: { name: 'Mr. Nehan Godage', registration_num: '1034' },
                    total: 34250.25,
                    receipt_type: 'Cheque',
                    date: '2024-01-21',
                    company_name: 'Piyestra West'
                },
                {
                    id: 6,
                    dealer_name: 'Laksiri Homes',
                    agent: { name: 'Mr. Laksiri Homes', registration_num: '5678' },
                    total: 98750.00,
                    receipt_type: 'Card Payment',
                    date: '2024-01-20',
                    company_name: 'Piyestra Furniture Pvt. Ltd'
                }
            ],
          permissions: { read: false, write: false, delete: false },
        }
    },

    methods: {
        ...mapActions(['updateSharedDataDailyCollection']),

        formatNumber(value) {
            return parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },

        clearDateRange() {
            this.dates = [];
        },

        backPageRoute() {
            this.$router.push('/dashboard');
        },

        fetchCollectionsData() {
            // API call would go here
            // For now using mock data
        },

        viewItem(item) {
            // Navigate to the view page with the item ID
            this.$router.push(`/daily-collections-view/${item.id}`);
        },

        confirmDelete(item) {
            this.itemToDelete = item;
            this.deleteDialog = true;
        },

        deleteItem() {
            const token = localStorage.getItem('token');
            const userId = localStorage.getItem('userId');
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/collections/daily/delete/${this.itemToDelete.id}`, { userId }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
                .then(() => {
                    this.collections = this.collections.filter(collection => collection.id !== this.itemToDelete.id);
                    this.deleteDialog = false;
                    this.itemToDelete = null;
                })
                .catch(error => {
                    console.error("There was an error deleting the collection!", error);
                });
        },

        exportPDF() {
            const doc = new jsPDF();
            doc.text('Daily Collections Analysis', 14, 10);

            const tableData = this.filteredCollections.map((item, index) => [
                index + 1,
                item.dealer_name || 'N/A',
                item.agent?.name || 'N/A',
                `LKR. ${this.formatNumber(item.total || 0)}`,
                item.receipt_type || 'N/A',
                item.date || 'N/A',
                item.company_name || 'N/A'
            ]);

            const tableColumns = ['#', 'Dealer Name', 'Sales Rep', 'Total', 'Receipt Type', 'Date', 'Company Name'];

            doc.autoTable({
                head: [tableColumns],
                body: tableData,
            });

            doc.save('daily_collections.pdf');
            this.logDocumentDownload('daily_collections.pdf', 'pdf');
        },

        exportExcel() {
            const tableData = this.filteredCollections.map((item, index) => ({
                '#': index + 1,
                'Dealer Name': item.dealer_name || 'N/A',
                'Sales Rep': item.agent?.name || 'N/A',
                'Total': `LKR. ${this.formatNumber(item.total || 0)}`,
                'Receipt Type': item.receipt_type || 'N/A',
                'Date': item.date || 'N/A',
                'Company Name': item.company_name || 'N/A'
            }));

            const worksheet = XLSX.utils.json_to_sheet(tableData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Daily Collections');
            XLSX.writeFile(workbook, 'daily_collections.xlsx');
            this.logDocumentDownload('daily_collections.xlsx', 'excel');
        },

        async logDocumentDownload(fileName, fileType) {
            try {
                const token = localStorage.getItem('token');
                const userId = localStorage.getItem('userId');

                await axios.post(`/api/log-document-download`, {
                    user_id: userId,
                    file_type: fileType,
                    file_name: fileName,
                    entity_area: 'Daily Collections',
                }, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
            } catch (error) {
                console.error('Error logging download:', error);
            }
        },

        setupEventListeners() {
            EventBus.on('dailyCollectionRecordButtonClick2', () => {
                this.fetchCollectionsData();
            });
        },

        removeEventListeners() {
            EventBus.off('dailyCollectionRecordButtonClick2');
        }
    },

    mounted() {
      this.permissions = getPermissions(0, "Module Name");

      // 3. CHECK READ ACCESS
      if (!this.permissions.read) {
        this.showSnackbar ? this.showSnackbar("Access Denied", "error") : alert("Access Denied");
        this.$router.push('/dashboard'); // Redirect to dashboard
      }
        this.setupEventListeners();
        this.fetchCollectionsData();
    },

    beforeUnmount() {
        this.removeEventListeners();
    },

    computed: {
        filteredCollections() {
            return this.collections.filter(collection => {
                const formatDate = (date, addOneDay = false) => {
                    if (!date) return null;
                    const d = new Date(date);
                    if (isNaN(d.getTime())) return null;
                    if (addOneDay) {
                        d.setDate(d.getDate() + 1);
                    }
                    return d.toISOString().split('T')[0];
                };

                const startDate = this.dates.length ? formatDate(this.dates[0], true) : null;
                const endDate = this.dates.length ? formatDate(this.dates[this.dates.length - 1]) : null;

                const startDateObj = startDate ? new Date(startDate) : null;
                const endDateObj = endDate ? new Date(endDate) : null;

                const collectionDate = collection.date;
                const collectionDateObj = collectionDate ? new Date(collectionDate) : null;

                const withinDateRange = !startDateObj || !endDateObj ||
                    (collectionDateObj && collectionDateObj >= startDateObj && collectionDateObj <= endDateObj);

                // Filter by selected agents
                const matchesAgent = this.selectedAgent.length === 0 ||
                    this.selectedAgent.includes(collection.agent?.value);

                // Filter by selected companies
                const matchesCompany = this.selectedCompany.length === 0 ||
                    this.selectedCompany.includes(collection.company_value);

                // Filter by selected dealers
                const matchesDealer = this.selectedDealer.length === 0 ||
                    this.selectedDealer.includes(collection.dealer_value);

                // Filter by selected areas
                const matchesArea = this.selectDistrict.length === 0 ||
                    this.selectDistrict.includes(collection.area);

                // Filter by selected status
                const matchesStatus = this.selectedStatus.length === 0 ||
                    this.selectedStatus.includes(collection.status);

                // Filter by selected receipt types
                const matchesReceiptType = this.selectedReceiptType.length === 0 ||
                    this.selectedReceiptType.includes(collection.receipt_type);

                return withinDateRange && matchesAgent && matchesCompany && matchesDealer &&
                    matchesArea && matchesStatus && matchesReceiptType;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
@use "../../styles/collection_management/collection_management.scss" as *;

</style>